"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeLetterResult = exports.serializeLetterResult = void 0;
var LetterResult_1 = require("../../results/LetterResult");
function serializeLetterResult(result) {
    return {
        "proper_letters": result.properLetters,
        "chosen_letters": result.chosenLetters,
        "number_correct": result.numberCorrect,
        "total_letters": result.totalLetters,
    };
}
exports.serializeLetterResult = serializeLetterResult;
function deserializeLetterResult(result) {
    var letterResult = new LetterResult_1.LetterResult();
    letterResult.chosenLetters = result.chosen_letters;
    letterResult.properLetters = result.proper_letters;
    letterResult.numberCorrect = result.number_correct;
    letterResult.totalLetters = result.total_letters;
    return letterResult;
}
exports.deserializeLetterResult = deserializeLetterResult;
